// desktop.guard.ts
import { Injectable } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { UsersApiService } from './services/users-api.service';

@Injectable({
    providedIn: 'root',
})
export class CanEditGuard implements CanActivate {
    constructor(private userApiService: UsersApiService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const id = route.parent?.params["id"];
        if (id == 0) {
            return of(true);
        }
        return this.userApiService.getAbilityToEditForUser(id).pipe(
            switchMap(isAble => {
                if (isAble) {
                    return of(true);
                } else {
                    return of(false);
                }
            })
        );
    }
}
